import { Component, inject } from '@angular/core';
import { routes } from 'src/routes';
import { RotorCompareService, RotorSearchService } from '../services';
import { ReportTemplateService } from '../services/report-template.service';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/services/config.service';
import { UserRightsService, PagesV2Module, LetDirective } from '@schenck/rotec-components';
import { UserRightsActions } from '../utils/enums/user-rights.enum';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

/**
 * Navigation component.
 */
@Component({
  selector: 'rc-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [
    PagesV2Module,
    RouterLinkActive,
    RouterLink,
    TranslateDirective,
    AsyncPipe,
    LetDirective,
  ],
})
export class PagesComponent {
  public compareService = inject(RotorCompareService);
  public searchService = inject(RotorSearchService);
  public editService = inject(ReportTemplateService);
  public configService = inject(ConfigService);
  public userRightsService = inject(UserRightsService);

  compareLink = routes.compare.absoluteUrl;
  searchLink = routes.search.absoluteUrl;
  editLink = routes.edit.absoluteUrl;
  numberOfTemplates$: Observable<number>;

  public actions = UserRightsActions;

  constructor() {
    this.numberOfTemplates$ = this.editService.onNumberOfTemplatesChanged();
  }
}
